function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?{\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-383941bb\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vux-loader/src/after-less-loader.js!less-loader?{'modifyVars':{'yellow':'#ffe26d','theme-color':'#FF9900','button-tab-border-color':'#ccc','button-tab-active-background-color':'@yellow','button-tab-active-font-color':'#000','switch-checked-bg-color':'@yellow','switch-checked-border-color':'@yellow','number-button-font-color':'#FF9900','number-round-button-enabled-border-color':'#FF9900','swiper-indicator-active-color':'#FF9900','checklist-icon-active-color':'#FF9900','tab-text-active-color':'#FF9900','tab-bar-active-color':'#FF9900','dialog-button-text-primary-color':'#FF9900','form-preview-button-primary-color':'#FF9900','tabbar-text-active-color':'#35495e','toast-position-top-offset':'56px','toast-position-bottom-offset':'60px','search-cancel-font-color':'#FF9900','radio-checked-icon-color':'#FF9900','calendar-arrow-color':'#c0c0c0'},'sourceMap':true}!../../node_modules/vux-loader/src/style-loader.js!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PlaceOrder.vue")
}
var normalizeComponent = require("!../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../node_modules/vux-loader/src/script-loader.js!../../node_modules/vux-loader/src/script-loader.js!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PlaceOrder.vue"
import __vue_script__ from "!!babel-loader!../../node_modules/vux-loader/src/script-loader.js!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PlaceOrder.vue"
/* template */
import __vue_template__ from "!!babel-loader?sourceMap!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-383941bb\",\"hasScoped\":true,\"buble\":{\"transforms\":{}}}!../../node_modules/vux-loader/src/before-template-compiler-loader.js!../../node_modules/vux-loader/src/template-loader.js!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PlaceOrder.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-383941bb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/PlaceOrder.vue
// module id = 849
// module chunks = 0